<template>
  <div class="block-notify-me">
    <div class="description-intro">
      <p class="mb-0">{{ $t('form-notify-me.email-notify-intro') }}</p>
    </div>
    <div class="block-email">
      <b-form ref="notify-form" data-vv-scope="form-notifyme"  @submit.prevent="handleSubmit" novalidate>
        <b-form-group>
          <base-input
          type="email"
          name="notify-email"
          v-model="email"
          :placeholder="$t('form-notify-me.enter-your-email')"
          class="input-email"
          v-validate="'required|email'"
          :validations="[{
              condition: errors.has('form-notifyme.notify-email'),
              text: errors.first('form-notifyme.notify-email')
          }]">
          </base-input>
        </b-form-group>
        <div class="block-actions">
          <div class="variant-active" v-show="sizeSelected">
            {{sizeSelected.label}}
          </div>
          <div class="block-actions__notify-cta">
            <button type="submit" class="btn btn-secondary btn-icon-text justify-content-between w-100">
              <span class="text">
                {{$t('form-notify-me.submit-button')}}
              </span>
              <svg class="o-icon"><use xlink:href="#user-line"></use></svg>
            </button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'
import { toast } from 'theme/modules/notifications'
import BaseInput from 'theme/components/Form/BaseInput'
import Logger from '@/services/Logger'

export default {
  inject: ['$validator'],
  name: 'NotifyMe',
  props: {
    product: {
      type: Object,
      required: true
    },
    productSelected: {
      type: Array | Object,
      required: true
    },
    variant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      email: this.$store.state.user.current ? this.$store.state.user.current.email : ''
    }
  },
  computed: {
    getProductByType () {
      // return product if it is array
      if (Array.isArray(this.productSelected)) {
        if (this.productSelected.length !== 1) {
          return console.error('Only accept single product')
        }
        return this.productSelected[0]
      }
      return this.productSelected
    },
    sizeSelected () {
      const _this = this
      if (this.product && this.product.variants) {
        let productAttr = find(this.product.variants, function (item) {
          return item.product.id === _this.getProductByType.id
        })
        if (productAttr && productAttr.attributes) {
          return productAttr.attributes[0]
        }
      } else {
        return false
      }
    }
  },
  methods: {
    clearForm () {
      this.email = this.$store.state.user.current ? this.$store.state.user.current.email : ''
      this.$validator.reset()
    },
    handleSubmit (evt) {
      if (evt) {
        evt.preventDefault()
      }

      if (this.productId !== -1) {
        const _this = this
        this.$validator.validateAll('form-notifyme').then(isValid => {
          if (isValid) {
            // actions here
            _this.$store.state.ui.loader = true
            _this.$store.dispatch('product/setNotify', { email: _this.email, productId: _this.getProductByType.id })
              .then(res => {
                toast.success(_this.$t('Request successful'))
                _this.clearForm()
              })
              .catch(() => {
                toast.error(_this.$t('GenericError'))
              })
              .finally(() => { _this.$store.state.ui.loader = false })
          }
        })
      } else {
        Logger.error('product id not valid, got -1')
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
